import HighlightText from 'components/HighlightedText';
import { useSearchContext } from 'contexts/SearchContext';
import type { ManagedFleet } from '../..';

interface CityCellProps {
  rowData: ManagedFleet;
}

export default function CityCell({ rowData: { city } }: CityCellProps) {
  const { searchString } = useSearchContext();
  return <HighlightText text={city ?? '-'} searchText={searchString} />;
}
